var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342.808,
    height: 125.434,
    viewBox: "0 0 342.808 125.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(-610.283 -1003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M509.607,107.344c-2.7-5-6-9.8-10.4-13.4a21.688,21.688,0,0,0-17.4-4.9,31.853,31.853,0,0,0-8.9,3.3c-2.1,1.2-4.2,2.4-6.3,3.7-.9.5-1.8,1.1-2.7,1.6-.1,0-.2.1-.3.1a2.507,2.507,0,0,0-.7.4,12.885,12.885,0,0,1-5.5,1.1,13.03,13.03,0,0,1-6.7-1.9c-.1-.1-.2-.1-.3-.2-2.7-1.6-5.4-3.2-8.1-4.7a28.1,28.1,0,0,0-8.9-3.3,21.141,21.141,0,0,0-17.4,4.9c-4.4,3.6-7.6,8.4-10.4,13.4-3,5.4-5.5,11.3-5.4,17.5s3.3,12.6,9,15a18.292,18.292,0,0,0,10.1.6c12.6-2.3,22.9-11.6,35.7-13.1.3,0,.6-.1.8-.1h.2a24.253,24.253,0,0,1,6,.4c11.9,2.1,21.9,10.6,33.8,12.8,3.4.6,7,.7,10.1-.6,5.7-2.3,8.9-8.8,9-15C515.107,118.644,512.607,112.744,509.607,107.344Zm-82,17.1a10,10,0,1,1,.1-20,9.9,9.9,0,0,1,9.9,10.1C437.807,119.744,433.107,124.444,427.607,124.444Zm74.2,1a3.849,3.849,0,0,1-3.4,2.3,3.894,3.894,0,0,1-3.2-1.3c-2-1.9-3.9-3.8-5.8-5.8a.654.654,0,0,0-1.1,0c-1.7,1.7-3.3,3.5-5,5.2a4.073,4.073,0,1,1-6.1-5.4c1.7-1.8,3.5-3.6,5.3-5.3.5-.5.5-.8-.1-1.4-2-1.9-4-3.9-5.9-5.9a3.77,3.77,0,0,1-.1-4.8,4,4,0,0,1,4.6-1.3,13.732,13.732,0,0,1,2,1.3c1.7,1.6,3.4,3.3,5,5,.6.7.8.6,1.4-.1,2-2,4-4.2,6.1-6a3.871,3.871,0,0,1,6.2,1.9c.1.3.1.7.2,1.1a4.505,4.505,0,0,1-1.2,3c-1.8,1.9-3.7,3.8-5.6,5.7-.7.7-.6.8,0,1.4,1.2,1.1,2.3,2.3,3.5,3.4.9.9,1.8,1.8,2.6,2.7A3.873,3.873,0,0,1,501.807,125.444Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M390.307,96.544a21.11,21.11,0,0,1,4.1-12.9c3.6-4.7,10.2-8.7,16.1-6.5a3.673,3.673,0,0,1,2.6,2.4,2.517,2.517,0,0,1-.2,2.1c-.7,1.5-14.5,20.5-15.6,21.8-.8,1-1.8,2-3.3,1.6a3.657,3.657,0,0,1-2.6-2.1A22.6,22.6,0,0,1,390.307,96.544Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M395.207,140.944c-2,.1-4-.7-4.6-2.8a3.471,3.471,0,0,1,.8-3.5,5.8,5.8,0,0,1,3.7-1.9,5.662,5.662,0,0,1,3.4.1,4.187,4.187,0,0,1,2.5,3.1,3.788,3.788,0,0,1-1.8,3.8,6.913,6.913,0,0,1-2.5,1C396.207,140.844,395.707,140.844,395.207,140.944Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M403.607,142.645h.2a3.726,3.726,0,0,1,2.7,1.5,4.349,4.349,0,0,1,.9,2.1,5.384,5.384,0,0,1-.9,3.2,6.385,6.385,0,0,1-1.9,2.1,4.394,4.394,0,0,1-2.7.7,4.117,4.117,0,0,1-2.1-1,3.8,3.8,0,0,1-1.3-1.8,4.819,4.819,0,0,1,.4-3.1,6.93,6.93,0,0,1,2-2.5A3.964,3.964,0,0,1,403.607,142.645Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M394.407,127.744a5.629,5.629,0,0,1-4.2-2,3.514,3.514,0,0,1-.6-3.8,3.671,3.671,0,0,1,3.2-2.4,5,5,0,0,1,4.7,1.9,3.464,3.464,0,0,1,.5,4A3.967,3.967,0,0,1,394.407,127.744Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M524.907,96.544a21.11,21.11,0,0,0-4.1-12.9c-3.6-4.7-10.2-8.7-16.1-6.5a3.673,3.673,0,0,0-2.6,2.4,2.517,2.517,0,0,0,.2,2.1c.7,1.5,14.5,20.5,15.6,21.8.8,1,1.8,2,3.3,1.6a3.657,3.657,0,0,0,2.6-2.1A19.553,19.553,0,0,0,524.907,96.544Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M520.007,140.944c2,.1,4-.7,4.6-2.8a3.471,3.471,0,0,0-.8-3.5,5.8,5.8,0,0,0-3.7-1.9,5.662,5.662,0,0,0-3.4.1,4.187,4.187,0,0,0-2.5,3.1,3.788,3.788,0,0,0,1.8,3.8,6.912,6.912,0,0,0,2.5,1C519.007,140.844,519.507,140.844,520.007,140.944Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M511.607,142.645h-.2a3.726,3.726,0,0,0-2.7,1.5,4.349,4.349,0,0,0-.9,2.1,5.384,5.384,0,0,0,.9,3.2,6.385,6.385,0,0,0,1.9,2.1,4.394,4.394,0,0,0,2.7.7,4.117,4.117,0,0,0,2.1-1,3.8,3.8,0,0,0,1.3-1.8,4.819,4.819,0,0,0-.4-3.1,6.931,6.931,0,0,0-2-2.5A3.964,3.964,0,0,0,511.607,142.645Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M520.807,127.744a5.629,5.629,0,0,0,4.2-2,3.514,3.514,0,0,0,.6-3.8,3.671,3.671,0,0,0-3.2-2.4,5,5,0,0,0-4.7,1.9,3.464,3.464,0,0,0-.5,4A3.967,3.967,0,0,0,520.807,127.744Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M451.707,89.544a4.123,4.123,0,0,1-5.6-1.5l-3.7-6.4a4.1,4.1,0,1,1,7.1-4.1l3.7,6.4A3.994,3.994,0,0,1,451.707,89.544Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M463.507,89.544a4.123,4.123,0,0,0,5.6-1.5l3.7-6.4a4.1,4.1,0,1,0-7.1-4.1l-3.7,6.4A4.076,4.076,0,0,0,463.507,89.544Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M536.307,97.645a33.686,33.686,0,0,0-2.4-15.7,29.19,29.19,0,0,0-19.2-16.4c-8.7-2.2-17.1-.1-25.5,2-.5.1-.9.4-1.3.5-1.5.3-3.4-.7-4.8-1-2-.5-4-.9-6-1.3a81.651,81.651,0,0,0-12.1-1.5c-1.8-.1-3.6-.2-5.4-.2-1.9-.1-3.6,0-5.2,0-1.3,0-2.6.1-4,.2-.5,0-1.1.1-1.6.1h-.2c-3.5.3-6.9.8-10.3,1.4-2,.4-4,.8-6,1.3-1.4.4-3.4,1.4-4.8,1-.5-.1-.9-.4-1.3-.5-8.4-2.1-16.9-4.2-25.5-2a28.969,28.969,0,0,0-19.2,16.4,33.687,33.687,0,0,0-2.4,15.7,47.9,47.9,0,0,0,1.6,9.2c.5,1.7,2.9,6,2.1,7.6-5.8,12-2.3,26.1,4,37.1a74.883,74.883,0,0,0,32,29.3c18.7,9,40.8,10.8,60.9,6a85,85,0,0,0,16.9-6,74.322,74.322,0,0,0,32-29.3c6.3-11,9.8-25.1,4-37.1-.8-1.6,1.6-5.9,2.1-7.6A57.115,57.115,0,0,0,536.307,97.645Zm-8.7,4.4c-1,4.5-2.5,9-2.2,13.7.2,3.4,1.5,6.6,1.9,10,.9,6.6-1.2,13.2-4.2,19.1a65.845,65.845,0,0,1-27.8,27.5,79.587,79.587,0,0,1-29,8.5h-1.5c-1.6,0-3.1.1-4.7.1h-5.2c-2.1,0-4.1-.1-6.2-.2a79.089,79.089,0,0,1-28.9-8.5,65.845,65.845,0,0,1-27.8-27.5c-3-5.9-5.1-12.6-4.2-19.1.5-3.4,1.7-6.6,1.9-10,.3-4.6-1.3-9.1-2.2-13.7-1.1-5.1-1.4-10.6.3-15.6a20.98,20.98,0,0,1,15.9-13.6c5.8-1,11.5.5,17.2,1.4a41.1,41.1,0,0,0,8.6.8c2.6-.1,5.1-1.1,7.6-1.6l3.8-.7a116.515,116.515,0,0,1,14.5-1.2h4a91.087,91.087,0,0,1,14.7,1.2l3.8.7c2.6.5,5,1.5,7.6,1.6a41.1,41.1,0,0,0,8.6-.8c5.6-1,11.4-2.4,17.2-1.4a20.823,20.823,0,0,1,15.9,13.6C528.907,91.545,528.607,96.944,527.607,102.044Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M481.607,145.344a4.008,4.008,0,0,0-3.2-2.8,3.614,3.614,0,0,0-3.6,1.5c-.3.4-.5.9-.8,1.3a18.826,18.826,0,0,1-1.6,2.3,4.922,4.922,0,0,1-4.9,1.4,20.4,20.4,0,0,1-5.4-1.9c-.1-.1-.3-.1-.4-.2h-.1c-.2-.1-.3-.2-.5-.2-.1,0-.2-.1-.3-.1-.2-.1-.3-.1-.5-.2s-.4-.1-.6-.2h-.1a8.788,8.788,0,0,0-5.5.5c-.1,0-.2.1-.3.1s-.2.1-.3.1c-.1.1-.3.1-.4.2a19.657,19.657,0,0,1-4,1.6h-.1c-.5.1-.9.2-1.4.3a4.984,4.984,0,0,1-4.9-1.4,18.822,18.822,0,0,1-1.6-2.3c-.3-.4-.5-.9-.8-1.3a3.614,3.614,0,0,0-3.6-1.5,4.008,4.008,0,0,0-3.2,2.8c-.9,2.7,1.5,6,3.3,7.8a14.632,14.632,0,0,0,7.1,3.9,13.453,13.453,0,0,0,6.9-.4h.1a18.637,18.637,0,0,0,6-2.5,1.049,1.049,0,0,1,1.3,0,21.274,21.274,0,0,0,6.3,2.5,13.817,13.817,0,0,0,13.9-3.6C480.207,151.344,482.607,148.044,481.607,145.344Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M466.607,137.044a4.023,4.023,0,0,0-1.8-4.1c-.1,0-.1-.1-.2-.1a.1.1,0,0,1-.1-.1,10.6,10.6,0,0,0-2.1-1.1c-.1-.1-.3-.1-.4-.2-.1,0-.1,0-.2-.1a11.934,11.934,0,0,0-3.7-.6,9.15,9.15,0,0,0-1.7.1,11.713,11.713,0,0,0-5.7,1.9,4.987,4.987,0,0,0-1.7,1.9,3.838,3.838,0,0,0,1.8,5.2c1.5.8,3,1.6,4.6,2.3a5.748,5.748,0,0,0,3.4.4h.1a.367.367,0,0,0,.3-.1c.1,0,.2-.1.3-.1.2-.1.5-.2.7-.3,1.4-.7,2.9-1.4,4.3-2.2.2-.1.4-.3.6-.4A4.122,4.122,0,0,0,466.607,137.044Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M586.307,111.744c0,9.9-4.4,16.7-16.4,16.6h-18.5v-44.5a18.1,18.1,0,0,1,18.1-18.1h.4c12.7,0,16.2,6.4,16.2,16,0,8.6-1.3,14.3-8.7,14.3,7.6.9,9,7.6,9,13.8v1.9Zm-15.1-28.7c0-7.6-.7-8.2-3.2-8.2a2.433,2.433,0,0,0-2.4,2.4v14.4h2.3c1.8,0,3.2-.3,3.2-5.8v-2.8Zm.4,25.2c0-6.2-.8-7.5-3.6-7.5h-2.3v18.5h2.6c2.2,0,3.3-1.1,3.3-5.8Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M617.107,128.344h-24.8v-62.6h14.4v53.5h10.4Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M621.507,128.344v-62.6h14.5v62.6Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M664.807,128.344l-10.7-37.6v37.6h-11.1v-62.6h15.5l10.2,36.7v-36.7h11v62.6Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M721.807,110.944c0,9.9-4.3,17.4-16.3,17.4h-18.6v-62.6h18.6c11.8,0,16.3,7.6,16.3,17.4Zm-14.4-27.8c0-7.6-.6-8.5-4.2-8.5h-2.1v44.6h2.1c3.1,0,4.2-1.1,4.2-8.3Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M563.407,142.944v13.8h7.8v7.6h-7.8v23.1h-12v-42.3a9.816,9.816,0,0,1,9.8-9.8h12.1v7.6Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M577.007,187.444v-52h22.7v7.6h-10.6v13.8h8.3v7.6h-8.3v15.6h10.6v7.6h-22.7Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M620.807,187.444l-3.8-23.4v-5.3h.8c1.4,0,2.2-1,2.2-5.6v-3.4c0-6.4-.6-6.7-3.1-6.7h-1.4v44.4h-11.9v-52h15.4c9.3,0,13.7,4.5,13.7,13.2v2.9c0,9.1-1.2,11.4-5.4,12.8l7.2,23.2h-13.7Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M654.807,187.444l-3.8-23.4v-5.3h.8c1.4,0,2.2-1,2.2-5.6v-3.4c0-6.4-.6-6.7-3.1-6.7h-1.4v44.4h-11.9v-52h15.4c9.3,0,13.7,4.5,13.7,13.2v2.9c0,9.1-1.2,11.4-5.4,12.8l7.2,23.2h-13.7Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M721.807,143.044h-7.1v44.4h-12v-44.4h-19.2v13.8h8.3v7.6h-8.3v15.6h10.6v7.6h-22.7v-52.2h42.7A7.683,7.683,0,0,1,721.807,143.044Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavlogo);
export default __webpack_public_path__ + "static/media/navlogo.defbbbbf8477b66a3c08b5382bd79096.svg";
export { ForwardRef as ReactComponent };